import * as React from 'react';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;

  .MuiLinearProgress-root {
    height: 10px;
    background-color: #ffffff;
    border-radius: 3px;
    span {
      background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    }
  }
`

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Box sx={{ width: '25%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="white">{`${Math.round(
          props.value,
        )}% ${t('propertyListPage_completed').toLowerCase()}`}</Typography>
      </Box>
    </Wrapper>
  );
}
